import store from "@/redux/store";
import { useNavigate } from "react-router-dom";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { loadUsers } from '@/reducers/User'
import { show } from '@/reducers/Modal'
import {Dashboard} from "@/views/dashboard/Dashboard";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";



class DashboardController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };

  }

      
  
  render() {
      return (
          <Dashboard {...this.props}/>
      );
      
  }
}
const DashboardControllerInit = (props) => {
        const navigate = useNavigate();

  return (
    <DashboardController
      {...props} navigate={navigate}
    />
  );
};

function mapStateToProps(state) {
    const {AuthReducer, UserReducer, TenantReducer, AdminUserReducer} = state;
    const {user, pavillion_url} = AuthReducer;     
  return {
    user: user,
    pavillion_url: pavillion_url

  };
}

export default connect(mapStateToProps)(DashboardControllerInit);  